import { render, staticRenderFns } from "./FloatButtons.vue?vue&type=template&id=48d47139&scoped=true"
import script from "./FloatButtons.vue?vue&type=script&lang=js"
export * from "./FloatButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatButtons.vue?vue&type=style&index=0&id=48d47139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d47139",
  null
  
)

export default component.exports